var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    stroke: "#2D5049",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1247_21966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 26.25V37.85C13.6574 42.3792 20.3073 45.5 28 45.5C35.6927 45.5 42.3426 42.3792 45.5 37.85V26.25",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 22.75L38.5 28.6881V47.25",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6818 8.75L3.5 21.3311L27.6818 33.25L52.5 21.3311L27.6818 8.75Z",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1247_21966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/education.a244aebbabd8f56f381b5230b362e18f.svg";
export { ForwardRef as ReactComponent };